import {
  IconWrapper,
  PrimaryButton,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import {
  Box,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ChapterTopicPopup } from 'apps/teacher/src/components/ChapterTopicPopup';
import { useEffect, useState } from 'react';

interface IProps {
  handlePrompt?: (prompt: string) => void;
}

export default function AiGeneratedButton(props: IProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { handlePrompt } = props;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [prompt, setPrompt] = useState('');
  useEffect(() => {
    if (!isPopupOpen) {
      setPrompt('');
    }
  }, [isPopupOpen]);
  return (
    <>
      <Box
        sx={{
          color: '#007CDC',
          border: '1px solid #0AA34F57',
          borderRadius: '16px',
          p: '4px 8px',
          cursor: 'pointer',
          background: '#D4FFE7',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          marginRight: 'auto',
          marginLeft: '10px',
        }}
        onClick={() => {
          if (handlePrompt) {
            setIsPopupOpen(true);
          }
        }}
      >
        <Typography color="#1D1D1D" variant="smallText">
          {isMobile ? 'AI' : 'AI Generated'}
        </Typography>
        <IconWrapper
          name="ai-icon"
          customSx={{
            height: '15px',
            width: '15px',
          }}
          type="png"
          parentFolder="icons"
        />
      </Box>
      <ChapterTopicPopup
        open={isPopupOpen}
        handleClose={() => {
          setIsPopupOpen(false);
        }}
        mainContainerSx={{
          height: '100%',
          width: '100%',
          p: { xs: pxToRem(18), md: pxTovW(24) },
        }}
        rootSx={{
          width: {
            xs: '90%',
            md: pxTovW(915),
          },
        }}
        popupBody={
          <Box>
            <Box
              sx={{
                paddingBottom: {
                  xs: pxToRem(8),
                  md: pxTovW(10),
                },
                borderBottom: '1px solid #E0E0E0',
                mb: { xs: pxToRem(14), md: pxTovW(20) },
              }}
            >
              <Typography variant="h2" fontWeight={600} fontFamily={'poppins'}>
                Edit Prompt to Update Question
              </Typography>
            </Box>
            <Box
              sx={{
                my: { xs: pxToRem(14), md: pxTovW(20) },
                backgroundColor: '#F5FAFF',
                border: '2px solid #A8D3FC',
                p: { xs: pxToRem(18), md: pxTovW(24) },
                borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 'bold',
                  color: '#222121',
                  mb: { xs: pxToRem(8), md: pxTovW(10) },
                }}
              >
                Type Prompt
              </Typography>
              <Box
                sx={{
                  boxSizing: 'border-box',
                  overflow: 'hidden',
                  height: { xs: pxToRem(100), md: pxTovW(83) },
                }}
              >
                <TextField
                  sx={{
                    boxSizing: 'border-box',
                    width: '100%',
                    // height: '100%',
                    height: { xs: pxToRem(100), md: pxTovW(83) },

                    borderRadius: pxToRem(9),
                    // paddingY: pxToRem(10),
                    backgroundColor: 'white',
                    overflowY: 'auto',
                    '&>div': {
                      '&::-webkit-scrollbar': { display: 'none' },
                    },
                    '& > div > textarea': {
                      '&::-webkit-scrollbar': { display: 'none' },
                      height: { xs: pxToRem(100), md: pxTovW(83) },
                    },
                  }}
                  placeholder={'Type Your Prompt Here...'}
                  multiline
                  rows={4}
                  variant="outlined"
                  value={prompt}
                  onChange={(e) => {
                    setPrompt(e.target.value);
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mt: { xs: pxToRem(16), md: pxTovW(20) },
                  gap: { xs: pxToRem(8), md: pxTovW(10) },
                }}
              >
                <PrimaryButton
                  sx={{
                    height: { xs: pxToRem(40), md: pxTovW(69) },
                    width: { xs: '100%', md: pxTovW(250) },
                    boxShadow: 'none',
                    backgroundColor: '#60F9A6',
                    border: '2px solid #03D563',
                  }}
                  onClick={() => {
                    setIsPopupOpen(false);
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 'bold',
                      color: 'black',
                    }}
                  >
                    CANCEL
                  </Typography>
                </PrimaryButton>
                <PrimaryButton
                  sx={{
                    height: { xs: pxToRem(40), md: pxTovW(69) },
                    width: { xs: '100%', md: pxTovW(250) },
                  }}
                  onClick={() => {
                    handlePrompt?.(prompt);
                    setIsPopupOpen(false);
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 'bold',
                      color: 'white',
                    }}
                  >
                    CHANGE QUESTION
                  </Typography>
                </PrimaryButton>
              </Box>
            </Box>
          </Box>
        }
      />
    </>
  );
}
